export const apiKey = process.env.REACT_APP_ACCESS_KEY;

export const BASE_URL = "https://api.openweathermap.org/data/2.5";